import { render, staticRenderFns } from "./CartoonList.vue?vue&type=template&id=4bbcbca4&scoped=true&"
import script from "./CartoonList.vue?vue&type=script&lang=js&"
export * from "./CartoonList.vue?vue&type=script&lang=js&"
import style0 from "./CartoonList.vue?vue&type=style&index=0&id=4bbcbca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbcbca4",
  null
  
)

export default component.exports